import { render, staticRenderFns } from "./SignupButton.vue?vue&type=template&id=7b87066d&scoped=true"
import script from "./SignupButton.js?vue&type=script&lang=js&external"
export * from "./SignupButton.js?vue&type=script&lang=js&external"
import style0 from "./SignupButton.scss?vue&type=style&index=0&id=7b87066d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87066d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default})
